import {Topbar} from '@blesk-frontend/ui';

import {FeedbackButton} from '@/components';
import {GuideCreateButton} from '@/features/guides';
import {TeamInviteButton} from '@/features/team';

export const GuideListTopbar = () => {
  return (
    <Topbar variant="sticky">
      <div className="flex h-10 gap-4">
        <FeedbackButton />
      </div>
      <div className="ml-auto flex h-10 gap-4">
        <TeamInviteButton />
        <GuideCreateButton />
      </div>
    </Topbar>
  );
};
